import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import * as staticsApi from '../../lib/api/statics';
import OrderStaticsEmpTable from '../../components/obtainorder_statics/OrderStaticsEmpTable';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const ObtainorderStaticsEmp = ({
  selectedYear,
  strMonth,
  endMonth,
  tableRef,
  searchData,
  selectPrjTyp,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  const onLoadData = async () => {
    setLoading(true);

    const searchData = {
      startDt: selectedYear + '-' + strMonth,
      endDt: selectedYear + '-' + endMonth,
      target: 'one'
    };

    try {
       const res = await staticsApi.getOrderStaticsByNew(
        selectPrjTyp,
        searchData,
      );
      if (res.data.list) {
        setData(res.data.list);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (searchData) {
      onLoadData();
    }
  }, [searchData]);

  const content = loading ? (
    <Box sx={{ display: 'flex' }}>
      <CircularProgress />
    </Box>
  ) : (
    <OrderStaticsEmpTable
      data={data || []}
      loading={loading}
      tableRef={tableRef}
      selectPrjTyp={selectPrjTyp}
      strMonth={strMonth}
      endMonth={endMonth}
    />
  );

  return content;
};

export default ObtainorderStaticsEmp;
